import React, { useEffect, useState, useLayoutEffect } from 'react';
import Navbar from '../components/navbar';
import { useTranslation } from 'react-i18next';
import SimpleFooter from '../components/simpleFooter';
import { HashLink as Link } from 'react-router-hash-link';
import ReactGA from 'react-ga';
import ReactMarkdown from 'react-markdown';

const BlogItem = (props) => {

	const blogId = props.match.params.id;

	let urlPrefix = 'https://s3.eu-west-1.amazonaws.com/ourmind-docs/blogposts/' + encodeURIComponent(blogId);

	// replace ä. Didn't work in safari as encoding was different
	// urlPrefix = urlPrefix.replace(/%C3%84/g, 'A%CC%88')
	// replace ö. Didn't work in safari as encoding was different
	// urlPrefix = urlPrefix.replace(/%C3%96/g, 'O%CC%88')

	const [blogMd, setBlogMd] = useState(null)

	const { t } = useTranslation();

	useEffect(() => {
		window.scrollTo(0, 0);

		//remove active class from menu
		let blogNavs = document.querySelectorAll(`a.blog-nav-item.active`)
		if (blogNavs.length > 0) {
			for (let link of blogNavs) {
				link.classList.remove('active')
			}
		}

		importBlog();

	}, [])

	useLayoutEffect(()=> {

		// modify link targets
		document.querySelectorAll('.blog-text a').forEach(elem => elem.setAttribute('target', '_blank'))
	})

	const importBlog = async () => {

		const postUrl = urlPrefix + '.md'

		try {
			fetch(postUrl).then(response => {
				return response.text()
			}
			).then(text => {
				if (text.slice(0, 1) === '<') {
					setBlogMd(`### Blog ${blogId} not found!`)
				} else {
					setBlogMd(text)
				}
			})
		} catch (error) {
			console.log(error)
			setBlogMd(`### Blog ${blogId} not found!`)
		}
	}

	const blogTitle = blogId
	let blogImgUrl = urlPrefix + '.jpg'
	// scandic letters doesn't work with url...
	if (blogTitle.startsWith("TIEDON")) {
		blogImgUrl = 'https://ourmind-docs.s3-eu-west-1.amazonaws.com/blogposts/TIEDON+HANKINTA+ETA%CC%88TYO%CC%88SSA%CC%88.jpg'
	}

	useEffect(() => {
		ReactGA.event({
			category: 'Blog posts',
			label: blogId,
			action: 'Opened blog post',
			value: 1
		});
	})

	return (
		<div>
			<Navbar />
			<div className="page-margin">

				<div className="breadcrumb-bg">
					<div className="container">
						<div className="row">
							<div className="col-md-6 col-sm-6 col-text-center d-align-center">
								<h2 className="title">{t('blog')}</h2>
							</div>
							<div className="col-md-6 col-sm-6 col-text-center">
								<nav aria-label="breadcrumb" className="blog-bradcrumb ">
									<ol className="breadcrumb bg-transparent mb-0">
										<li className="breadcrumb-item"><Link to="/#home">{t('home')}</Link></li>
										<li className="breadcrumb-item"><Link to="/blog">{t('blog')}</Link></li>
										<li className="breadcrumb-item active"><a href={null}>{blogTitle}</a></li>
									</ol>
								</nav>
							</div>
						</div>
					</div>
				</div>

				<section>
					<div className="container">
						<div className="row">
							<div className="col-sm-12">
								<div className="blog-item">
									<div className="blog-block">
										<div className="blog-box">
											<div className="overflow-hidden">
												<a href={null}>
													<img src={blogImgUrl} alt="blog" className="img-fluid" />
												</a>
											</div>
										</div>
									</div>
									<div className="blog-text">
										<a href={null}>
											<h3 className="blog-head">{blogTitle}</h3>
										</a>
										<div className="blog-divider"></div>
										<div className="blog-description">
											<ReactMarkdown source={blogMd} />
										</div>
									</div>
								</div>

								<div className="blog-divider"></div>

							</div>
						</div>
					</div>
				</section>

				{/*Footer Section start*/}
				<SimpleFooter />
				{/*Footer Section End*/}

			</div>
		</div>
	);
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/blog/BlogItem.js